import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

interface DialogDataOutput {
  id: string,
  integrationType:string,
  version: string,
}
export interface DialogData {
  data: {
    apiID: string,
    apiVersion: string,
  }
}

export interface DialogData {
  title?: string;
  bookDate?:string;
  placeholder?: string;
  content?: string;
  showTextBox: boolean;
  no: string;
  yes: string;
  hideYesBtn: boolean;
  hideNoBtn: boolean;
  value?: any;
  labelTitle:string;
  labelName:string;
  showDate:boolean;
  dateLimit?:boolean;
}

@Component({
  selector: 'update-api-dialog',
  templateUrl: 'update-api-dialog.html',
})
export class UpdateApiDialog {
  apiVerForm: FormGroup;
  apiID: any;
  apiVer: any;
  dialogData: any[] = [];
  ngModelData: any;
  Apis:any[]=[];
  selectedApi: string = null;

  constructor(
    public dialogRef: MatDialogRef<UpdateApiDialog>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.Apis = data.data
    this.dialogData = this.Apis;
    this.apiVerForm = new FormGroup({
      version: new FormControl(""),      
    });
  }

  displayApiVersion(obj?:DialogDataOutput): string | undefined{
    return obj ? obj.version : undefined;
  }

  onChangeSearchedApi(value: string) {
    let api = this.Apis;
    if (typeof value !== "object") {
      if (value) {
        api = this.Apis.filter((y: DialogDataOutput) =>
          y.version.toUpperCase().trim().includes(value.toUpperCase().trim())
          || y.version.toUpperCase().trim().includes(value.toUpperCase().trim())
        );
      }
    }
    this.dialogData = Object.assign([], api);
  }

  onChangeSelectedApi(val: DialogDataOutput) {
    this.selectedApi = val.id;
  }

  save() {
    if (this.selectedApi) {
      this.dialogRef.close({
        apiID: this.selectedApi
      });
    }
  }
  close() {
    this.dialogRef.close();
  }
}